import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';

class Text extends PureComponent {
    static propTypes = {
        content: PropTypes.string,
    };

    constructor(props) {
        super(props);

        this.state = {};

        this.ref = React.createRef();
    }

    render() {
        const { content } = this.props;

        return (
            <div className={'textContainer fillImage'} dangerouslySetInnerHTML={{ __html: content }} ref={this.ref} />
        );
    }
}

export default errorBoundary(Text);
